<div class="checkbox-list">

  <div class="checkbox-list__header" *ngIf="showGroupName">
    <div class="checkbox-list__header--group-name">{{groupName}}</div>

    <div class="checkbox-list__header--switch" *ngIf="canSelectAll">
      selecionar tudo
      <nz-switch class="ml-2" [ngModel]="allSelected" (ngModelChange)="toggle()"></nz-switch>
    </div>

  </div>

  <div class="checkbox-list__body">

    <div class="checkbox-list__body--row" *ngFor="let option of options">

      <label nz-checkbox [class.checked]="option.checked" [nzChecked]="option.checked"
        (nzCheckedChange)="select(option, $event)">
        <span *ngIf="!isIndexableFilter(option.value)">
          {{option.label}}
        </span>

        <a [attr.href]="setHref(option)" class="ant-checkbox-wrapper" *ngIf="isIndexableFilter(option.value)">
          {{option.label}}
        </a>

      </label>
    </div>
  </div>
</div>
